import { updateClient, clients, clientAddForm,deleteClient, isCurrentUserAdmin } from "../actions/admin";
import { useDispatch } from 'react-redux';
import { useState, useEffect, useCallback, useMemo } from "react";
import { MaterialReactTable } from 'material-react-table';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import AddBoxIcon from '@mui/icons-material/AddBox';
import Edit from '@mui/icons-material/Edit';
import EventNoteIcon from '@mui/icons-material/EventNote'
import Delete  from '@mui/icons-material/Delete';

import { MenuItem, Box, Typography, TextField, Select } from '@mui/material';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormFeedback, FormText } from 'reactstrap';
import VisitiOutcomeModal from "./visitoutcomes.modal.component";
import Download from "@mui/icons-material/Download";
import EditingClientModal from "./editingclient.modal.component";
import NewClientModal from "./newclient.modal.component"
import { ExportToCsv } from 'export-to-csv'; //or use your library of choice her

const Clients = (props) => {
    const [showModalEditing, setShowModalEditing] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [tagList, setTagList] = useState();
    const dispatch = useDispatch();
    const [showModalNew, setShowModalNew] = useState(false);
    const [showModalVisit, setShowModalVisit] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const [visitList, setVisitList] = useState([]);
    const [rowSelection, setRowSelection] = useState({});
    const [currentRow, setCurrentRow] = useState({});
    const [countryList, setCountryList] = useState({});
    const [tableData, setTableData] = useState([]);
    const [apiData, setApiData] = useState({
        countryList: []
    })
    const [formData, setFormData] = useState({
        id: "",
        firstname: "",
        lastname: "",
        email: "",
        cell: [""],
        info: "",
        countryname: "",
        countryId: "",
        formErrors: { email: '', cell: [""] }
    });

    const toggleModalNew = () => {
        setShowModalNew(!showModalNew)
    };
    const realoadList = (data) => {
        setTagList(data);
    };
    const toggleModalEditing = (row) => {

        if (row != null && row.original) {
            setFormData({
                ...formData,
                id: row.original.id,
                firstname: row.original.firstname,
                lastname: row.original.lastname,
                email: row.original.email,
                cell: row.original.cell,
                countryId: row.original.countryId,
                info: row.original.info
            });
        } else {
            setFormData({
                id: "",
                firstname: "",
                lastname: "",
                email: "",
                cell: [""],
                info: "",
                countryname: "",
                countryId: "",
                formErrors: { email: '', cell: '' }
            });
        }
        setShowModalEditing(!showModalEditing)
    };

    const toggleModalVisit = (row) => {
        if (row != null && row.original) {
            setFormData({
                ...formData,
                id: row.original.id
            });
        }
        setShowModalVisit(!showModalVisit)
        if (showModalVisit) { // is closing
            setVisitList([]);
        }

    };
    useEffect(() => {
        dispatch(clients())
            .then((data) => {
                setTagList(data);
                setLoading(false);
            })
            .catch(() => {
                console.log("Error");
            });
        dispatch(clientAddForm())
            .then((data) => {
                setApiData(data);
            })
            .catch(() => {
                console.log("Error");
            });
    }, []);

    const getCommonEditTextFieldProps = useCallback(
        (cell) => {
            return {
                error: !!validationErrors[cell.id],
                helperText: validationErrors[cell.id],
                onBlur: (event) => {
                    const isValid =
                        cell.column.id === 'email'
                            ? validateEmail(event)
                            : cell.column.id === 'cell' && cell.value !== ""
                                ? validateCell(event)
                                : false
                    if (!isValid) {
                        setValidationErrors({
                            ...validationErrors,
                            [cell.id]: `Il campo ${cell.column.columnDef.header} non è valido`,
                        });
                    } else {
                        delete validationErrors[cell.id];
                        setValidationErrors({
                            ...validationErrors,
                        });
                    }
                },
            };
        },
        [validationErrors],
    );

    const columns = useMemo(
        () => [{
            accessorKey: 'id',
            header: 'Id',
            enableEditing: false
        },
        {
            accessorKey: 'firstname',
            header: 'Nome'
        },
        {
            accessorKey: 'lastname',
            header: 'Cognome'
        },
        {
            accessorKey: 'email',
            header: 'Email',
            muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                ...getCommonEditTextFieldProps(cell),
                type: 'email',
            }),
        },
        {
            accessorKey: 'cellString',
            header: 'Cellulare',
            muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                ...getCommonEditTextFieldProps(cell)
            })
        },
        {
            accessorKey: 'info',
            header: 'Info'
        }
            ,
        {
            accessorKey: 'countryname',
            header: 'Paese'
        }

        ],
        [getCommonEditTextFieldProps],
    );
    const handleDeleteRow = useCallback(
        (row) => {
            if (
                !window.confirm(`Sei sicuro di voler cancellare il cliente ${row.getValue('lastname')}`)
            ) {
                return;
            }
            dispatch(deleteClient(row.getValue('id')))
                .then((data) => {
                    dispatch(clients())
                    .then((data) => {
                        realoadList(data);
                    })
                    .catch(() => {
                        console.log("Error");
                    });
                })
                .catch(() => {
                    console.log("Error");
                });
            tableData.splice(row.index, 1);
            setTableData([...tableData]);
        },
        [tableData],
    );

    const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
        tagList[row.index] = values;;
        if (values['cell'] === "") {
            values['cell'] = null;
        }
        dispatch(updateClient(values))
            .then((data) => {
                //window.location.reload();
            })
            .catch((error) => {
                alert(error.response.data.message);
            });
        setTagList([...tagList]);
        exitEditingMode();
    };



    const validateCell = (index, e) => {
        var passwdRex = /^\d+$/;
        let ret = true;
        let validate = formData.formErrors;
        if (passwdRex.test(e.target.value)) {
            validate.cell[index] = 'has-success';
        } else {
            validate.cell[index] = 'has-danger';
            ret = false;
        }

        setFormData({
            ...formData,
            formErrors: validate
        });
        return ret;
    };


    const validateEmail = (e) => {
        const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let ret = true;
        let validate = formData.formErrors;

        if (emailRex.test(e.target.value)) {
            validate.email = 'has-success';
        } else {
            validate.email = 'has-danger';
            ret = false;
        }

        setFormData({
            ...formData,
            formErrors: validate
        });
        return ret;
    };

    const csvOptions = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        useBom: true,
        useKeysAsHeaders: false,
        headers: columns.map((c) => c.header),
    };

    const csvExporter = new ExportToCsv(csvOptions);


    const handleDownloadProperty = (rows) => {
        if(!isCurrentUserAdmin()) {
            alert("Operazione non consentita");
            return;
        }
        if (rows.length == 0) {
            alert("Non è stato selezionato alcun record!");
            return;
        }
        let selRows = [];
        let keys = Object.keys(rowSelection);
        keys.forEach(key => {
            if (rowSelection[key]) {
                selRows.push(rows[key])
            }
        });
        if (selRows.length == 0) {
            csvExporter.generateCsv(rows.map((row) => {
                let newrow = {
                    id: row.id,
                    firstname: row.original.firstname,
                    lastname: row.original.lastname,
                    email: row.original.email,
                    cell: row.original.cell,
                }

                return newrow;
            }
            ));
        } else {
            csvExporter.generateCsv(selRows.map((row) => {
                let newrow = {
                    id: row.id,
                    firstname: row.original.firstname,
                    lastname: row.original.lastname,
                    email: row.original.email,
                    cell: row.original.cell,
                }

                return newrow;
            }));
        }
    }


    if (isLoading) {
        return <div className="Tags">Loading...</div>;
    }

    return (
        <div>
            <MaterialReactTable
                columns={columns}
                data={tagList}
                initialState={{ columnVisibility: { id: false } }}
                enableRowSelection
                editingMode="modal"
                enableEditing
                onEditingRowSave={handleSaveRowEdits}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: '', //change header text
                        size: 160 //make actions column wider
                    },
                }}
                defaultColumn= {{
                    maxSize: 400,
                    minSize: 20,
                    size: 180, //default size is usually 180
                  }}
                  enableColumnResizing
                  columnResizeMode='onChange'
                renderRowActions={({ row, table }) => (
                    <Box sx={{ display: 'flex', gap: '1rem' }}>
                        <Tooltip arrow placement="left" title="Edit">
                            <IconButton onClick={() => { if(row.original.editable) {toggleModalEditing(row)}}}>
                                <Edit />
                            </IconButton>
                        </Tooltip>
                        <Tooltip arrow placement="right" title="Note">
                            <IconButton onClick={() => toggleModalVisit(row)}>
                                <EventNoteIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip arrow placement="right" title="Cancella">
                                    <IconButton color="error" onClick={() =>{if(row.original.deletable) {handleDeleteRow(row)}}}>
                                        <Delete />
                                    </IconButton>
                                </Tooltip>
                    </Box>
                )}
                renderTopToolbarCustomActions={(table) => {
                    const handleCreateNewUser = () => {

                        setShowModalNew(true);
                    };

                    return (
                        <div>
                            <Tooltip arrow title="Create New Client">
                                <IconButton onClick={handleCreateNewUser}>
                                    <AddBoxIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip arrow title="Download">
                                <IconButton onClick={() => handleDownloadProperty(table.table.getSelectedRowModel().rows)}>
                                    <Download />
                                </IconButton>
                            </Tooltip>

                        
                            <VisitiOutcomeModal showModalVisit={showModalVisit} toggleModalVisit={toggleModalVisit} formData={formData} />

                        </div>
                    );
                }}
            />
            <NewClientModal showModalNew={showModalNew} toggleModalNew={toggleModalNew} formData={formData} setFormData={setFormData} apiData={apiData} setApiData={setApiData} validateCell={validateCell} validateEmail={validateEmail} realoadList={realoadList}/>
            <EditingClientModal showModalEditing={showModalEditing} toggleModalEditing={toggleModalEditing} formData={formData} setFormData={setFormData} currentRow={currentRow} apiData={apiData} setApiData={setApiData} validateCell={validateCell} validateEmail={validateEmail} realoadList={realoadList}/>


        </div>

    );
}

export default Clients;